import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPatientLookup, getCountDetails,getPatientIdList } from "../../api/list";

interface PatientLookupState {
  patientlookup: {
    data: any[];
    limit: number;
    page: number;
    total_count: number;
    total_pages: number;
  };
  isLoading: boolean;
  count: any[];
  error: string | null;
  searchPatientList: any[];
}

const initialState: PatientLookupState = {
  patientlookup: {
    data: [],
    limit: 15,
    page: 1,
    total_count: 0,
    total_pages: 0,
  },
  isLoading: false,
  count: [],
  error: null,
  searchPatientList: [],
};

export const fetchPatientLookup = createAsyncThunk(
  "patientlookup/fetchPatientLookup",
  async (params: any, { getState }) => {
    const res: any = await getPatientLookup(params);
    return res;
  }
);

export const fetchCountDetails: any = createAsyncThunk(
  "patientlookup/fetchCountsDetails",
  async (params: any, { rejectWithValue }) => {
    try {
      return await getCountDetails(params);
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch count details");
    }
  }
);

export const fetchSearchPatientList = createAsyncThunk(
  "patientlookup/fetchSearchPatientList",
  async (params: any, { getState }) => {
    const res: any = await getPatientIdList(params);
    return res;
  }
);


export const patientlookupSlice = createSlice({
  name: "patientlookup",
  initialState,
  reducers: {
    setPatientlookup: (state, action) => {
      state.patientlookup = action.payload;
    },
    setCountDetails: (state, action) => {
      state.count = action.payload;
    },
    setSearchPatientList: (state, action) => {
      state.searchPatientList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatientLookup.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPatientLookup.fulfilled, (state, action) => {
        state.isLoading = false;
        const newData = action.payload?.data || [];
        const currentPage = action.payload?.page || 1;

        if (currentPage === 1) {
          // Replace data for the first page
          state.patientlookup = {
            data: newData,
            limit: action.payload?.limit || 15,
            page: currentPage,
            total_count: action.payload?.total_count || 0,
            total_pages: action.payload?.total_pages || 0,
          };
        } else {
          // Append data for subsequent pages
          state.patientlookup = {
            ...state.patientlookup,
            data: [...state.patientlookup.data, ...newData],
            page: currentPage,
            total_count: action.payload?.total_count || state.patientlookup.total_count,
            total_pages: action.payload?.total_pages || state.patientlookup.total_pages,
          };
        }
      })
      .addCase(fetchPatientLookup.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCountDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCountDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.count = action.payload;
      })
      .addCase(fetchCountDetails.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSearchPatientList.fulfilled, (state, action) => {
        state.isLoading = false;
        const newData = action.payload?.data || [];
        const currentPage = action.payload?.page || 1;
        if (currentPage === 1) {
          // Replace data for the first page
          state.searchPatientList = newData
            
        } else {
          // Append data for subsequent pages
          state.searchPatientList = [...state.searchPatientList, ...newData]
        }
      })
      .addCase(fetchSearchPatientList.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setPatientlookup, setCountDetails } = patientlookupSlice.actions;

export default patientlookupSlice.reducer;